<template>
  <div class="employee__auctions">
    <div class="container container--employee employee-orders-list">
      <div class="row no-gutters">
        <AuctionsCatalogsSidebar />
        <div class="col-sm-9 auctions__list">
          <FinishedAuctionsCatalogsList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FinishedAuctionsCatalogsList from './finished/list';
import AuctionsCatalogsSidebar from './auctions_catalogs_sidebar';

export default {
  name: 'FinishedAuctionsCatalogs',
  components: {
    FinishedAuctionsCatalogsList,
    AuctionsCatalogsSidebar,
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished_auctions_catalogs.vue?2fabcd24